import React from 'react';
import { Button } from './ui/Button';
export function Navbar() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <nav className="sticky top-0 z-50 bg-carbon/90 backdrop-blur-xl border-b border-white/5 transition-all" data-id="element-233">
      <div className="absolute top-0 left-0 w-full h-[2px] bg-gold" data-id="element-234" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between" data-id="element-235">
        <img src="https://cdn.magicpatterns.com/uploads/mfEytma2VuVhmeK6WHR1zC/IMG_6635.jpg" alt="Doctor Ecommerce" className="h-8 md:h-10 object-contain" data-id="element-236" />
        <div className="flex items-center gap-8" data-id="element-237">
          <a href="tel:4028720639" className="hidden md:block text-gold font-semibold hover:text-white transition-colors tracking-widest text-sm" data-id="element-238">
            📞 (402) 872-0639
          </a>
          <Button onClick={scrollToContact} className="!py-2.5 !px-6 text-xs md:text-sm" data-id="element-239">
            AGENDA GRATIS
          </Button>
        </div>
      </div>
    </nav>;
}